
<button class="add_button" type="button" (click)="openDialogAddEditLicence('add', federation)" appChangeColorTheme attribute="bgc" matTooltip="Ajouter une licence">
  <fa-icon [icon]="getFaIcon('faPlus')"></fa-icon>
  <span>Ajouter une licence</span>
</button>

<section [hidden]="!licences || licences?.length === 0 || isLoading" class="content">
  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Label</th>
      <td mat-cell *matCellDef="let licence"> {{ licence.label }}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
      <td mat-cell *matCellDef="let licence">{{ licence.description}} </td>
    </ng-container>

    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Prix </th>
      <td mat-cell *matCellDef="let licence">{{ licence.price}}€ </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
      <td mat-cell *matCellDef="let licence">
        <fa-icon [icon]="getFaIcon('faEdit')" matTooltip="Editer la licence" appChangeColorTheme attribute="color" (click)="openDialogAddEditLicence('edit', federation, licence)"></fa-icon>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header-row"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row">
    </tr>
  </table>
  <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    (page)="pageEvent = $event" [color]="color">
  </mat-paginator>
</section>

<mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>

<ng-container *ngIf="!licences ||licences?.length === 0 && !isLoading">
  <p>Il n'y a pas de licences sur cette fédération.
  </p>
</ng-container>
